
import React from 'react';
import MedicationCard from './MedicationCard';
import { medications, categoryNames, Medication } from '../data/medications';

interface CategorySectionProps {
  category: 'weight-loss' | 'mens-health' | 'womens-health' | 'peptides' | 'injectables' | 'additional';
  filteredMedications?: Medication[];
}

const CategorySection: React.FC<CategorySectionProps> = ({ 
  category, 
  filteredMedications 
}) => {
  // If filtered medications are provided, use them; otherwise use all medications for this category
  const categoryMedications = filteredMedications || 
    medications.filter(med => med.category === category);
  
  console.log(`Rendering category ${category} with ${categoryMedications.length} medications`);
  console.log('First medication clinicalDetails:', categoryMedications[0]?.clinicalDetails);

  return (
    <section id={category} className="category-section py-12 pt-20">
      <div className="container">
        <h2 className="mb-8 scroll-mt-20">{categoryNames[category]}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categoryMedications.map((medication) => (
            <MedicationCard
              key={medication.id}
              name={medication.name}
              description={medication.description}
              research={medication.research}
              url={medication.url}
              Icon={medication.Icon}
              video={medication.video}
              clinicalDetails={medication.clinicalDetails}
              availablePreparations={medication.availablePreparations}
              adverseReactions={medication.adverseReactions}
              category={medication.category}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
